import { debounce } from 'lodash';
import TextInput from '../../forms/controls/TextInput';
import IInputChangeHandler from '../../forms/IInputChangeHandler';

export default class EditableZonePriceInputChangehandler implements IInputChangeHandler {
  input: TextInput;

  minimumAmount: number;

  cb: () => void;

  fire: (this: HTMLInputElement, ev: Event) => any;

  constructor(input: TextInput, minimumAmount: number, cb: () => void) {
    this.input = input;
    this.minimumAmount = minimumAmount;
    this.cb = cb;

    this.fire = debounce(() => {
      this.onUpdate();
    }, 400);
  }

  start() {
    const $input = this.input.$inputs[0];

    $input.addEventListener('change', this.fire);
    $input.addEventListener('input', this.fire);
    $input.addEventListener('blur', this.fire);
  }

  stop() {
    const $input = this.input.$inputs[0];

    $input.removeEventListener('change', this.fire);
    $input.removeEventListener('input', this.fire);
    $input.removeEventListener('blur', this.fire);
  }

  onUpdate = () => {
    this.cb();
  };
}
